export default __webpack_public_path__ + "static/media/sports (4).bbef1ff3.jpg";